import React from 'react'
import Button from '../../../../../../../Components/Buttons/Button'
import { withRouter } from 'react-router-dom'

const Anonymous = ({ history }) => {
  return (
    <div className='anonymous'>
      <div className='loginInRequest'>
        <p>To see the timing plan please sign-up/login</p>
        <Button
          onClick={() => history.push('/auth')}
          name={'Login'}
          type={'primary big'}
        />
      </div>
    </div>
  )
}

export default withRouter(Anonymous)
